import { TMagicItem, TCouponModule } from "services/page/admin";
import { genPrmLink } from "utils/url";
import { multilingualImgDisplay, multilingualLinkDisplay } from "utils/mutil-Language";
import { PrmParams } from "../prm";
import { isNotBlankArray } from "utils/array";
import { CommonRuntime } from "utils/runtime";
import { GetAutoLink } from "utils/browser/app";
import { MWEB_MINWIDTH } from "views/mobile/constants";
import { TNewBannerItem } from "services/page/modules";
import { RenderCoupon } from "views/mobile/components/MCouponCode";
import { TBannerItem as BannerItemProps } from "views/services/banner";
import { Platform } from "utils/runtime";

export interface TransformBannerOptions {
	maxWidth?: number;
}
// 普通图片占位图
export const bannerPlaceholder = "https://litb-cgis.rightinthebox.com/imagegy/202101/e3fdaafad90a4a8a8cb83048d17e3738mini_square_1200.png";
// 轮播、导购、吸底Tab占位图
export const bannerPlaceholder456 = "https://litb-cgis.rightinthebox.com/imagegy/202101/ce862fe839bb4667ae445656dcd5b6bdmini_square_200.png";
export const formatAspect = (side: string | number) => {
	if (typeof side === "string" && isNaN(+side)) {
		return 0;
	}
	return +side;
};

export const transformMagicLinks = (
	index: number,
	runtime: CommonRuntime,
	items: TMagicItem[] = [],
) => {
	if (isNotBlankArray(items)) {
		return items.map((item, i) => ({
			...item,
			link: genPrmLink(
				{
					floor: index + 1,
					position: i + 1,
				},
				runtime,
				transformPosterUrl(item.link, runtime, true),
			),
		}));
	}
	return items;
};

export const transformNavIcons = (
	navs: TNewBannerItem[],
	runtime: CommonRuntime,
	prm: PrmParams,
): { bgColor: string; navs: BannerItemProps[] } => {
	const firstBgColor = navs?.[0].ui?.bgColor;
	const nextNavs = navs.reduce(
		(result: BannerItemProps[], nav: TNewBannerItem, index: number) => {
			const { img, link, text, width, height, bgColor } = transformBanner(nav, runtime, {
				...prm,
				position: index,
			});
			const nextNav: BannerItemProps = {
				img,
				link,
				text,
				width,
				height,
				bgColor: bgColor || firstBgColor,
			};
			return [...result, nextNav];
		},
		[],
	);
	return {
		bgColor: firstBgColor,
		navs: nextNavs,
	};
};

export const tranformCouponInfo = (
	coupons: TCouponModule[] = [],
	runtime: CommonRuntime,
): RenderCoupon[] => {
	const resCoupon: RenderCoupon[] = [];
	coupons.map((item: TCouponModule) => {
		resCoupon.push({
			img: multilingualImgDisplay(item.info, runtime),
			code: item.couponCode,
			width: +item.info.width,
			height: +item.info.height,
		});
	});

	return resCoupon.filter((ele) => !!ele?.img);
};

export const formatBannerSize = ({
	width,
	height,
}: {
	width: number | string;
	height: number | string;
}) => {
	const bannerWidth = formatAspect(width || "");
	const bannerHeight = formatAspect(height || "");
	const aspectRatio = bannerWidth ? (+bannerHeight / bannerWidth).toFixed(3) : 0;

	return {
		width: Math.max(bannerWidth, MWEB_MINWIDTH),
		height: aspectRatio ? `${(+aspectRatio * 100).toFixed(3)}vw` : "auto",
		aspectRatio,
	};
};

const formatBannerPCSize = ({
	width,
	height,
	maxWidth,
}: {
	width: number | string;
	height: number | string;
	maxWidth?: number;
}) => {
	const bannerWidth = formatAspect(width || "");
	const bannerHeight = formatAspect(height || "");
	const aspectRatio = bannerWidth ? (+bannerHeight / bannerWidth).toFixed(3) : 0;
	const nextWidth = maxWidth ? Math.min(maxWidth, bannerWidth) : bannerWidth;
	return {
		width: nextWidth,
		height: aspectRatio ? `${(+aspectRatio * nextWidth).toFixed(3)}` : "auto",
		aspectRatio,
	};
};

export interface TBannerItemNew extends BannerItemProps {
	aspectRatio?: number;
}

export const transformBanner = (
	banner: TNewBannerItem,
	runtime: Partial<CommonRuntime>,
	prm: PrmParams,
	options: TransformBannerOptions = {},
): TBannerItemNew => {
	const { width, height, title } = banner;
	const { maxWidth } = options;

	let link = multilingualLinkDisplay(banner, runtime);
	const img = multilingualImgDisplay(banner, runtime);
	const imgTwo = multilingualImgDisplay(banner, runtime, true);
	link = transformPosterUrl(link, runtime, true);
	link = GetAutoLink(genPrmLink({ floor: prm?.floor, position: prm?.position }, runtime, link));

	let nextSize = formatBannerSize({
		width,
		height,
	});
	if (prm?.platform === Platform.WEB) {
		nextSize = formatBannerPCSize({
			width,
			height,
			maxWidth: options?.maxWidth,
		});
	}
	if (prm?.platform === Platform.WEB) {
	}
	const aspectRatio = width ? +(+height / +width).toFixed(3) : 0;
	const nextWidth = maxWidth ? Math.min(maxWidth, nextSize.width) : nextSize.width;

	return {
		link,
		img,
		imgTwo,
		text: title,
		width: nextWidth.toString(),
		height: maxWidth ? (aspectRatio * nextWidth).toFixed(3) : nextSize.height.toString() || "",
		aspectRatio,
	};
};

export const transformBanners = (
	banners: TNewBannerItem[],
	runtime: CommonRuntime,
	prm: PrmParams,
	options?: TransformBannerOptions,
): BannerItemProps[] => {
	return banners.map((banner, idx) => {
		return transformBanner(banner, runtime, { ...prm, position: idx + 1 }, options);
	});
};

/**
 * m站底部tab临时用法， 以后都用transformBanners代替
 */
export const transformStickTabBanners = (
	banners: TNewBannerItem[] = [],
	runtime: CommonRuntime,
	prm: PrmParams,
) => {
	const nextBanners = transformBanners(banners, runtime, prm);
	return nextBanners.map((item) => {
		const { img, imgTwo, link, ...others } = item;
		return {
			img: link ? img : imgTwo,
			link,
			...others,
		};
	});
};

// aspectRatio 高宽比列
export const getCardBannerItemSize = (aspectRatio: string = "") => {
	const ratio = +aspectRatio.replace(/(?:auto|vw)/gi, "");
	if (ratio > 100) {
		return {
			itemWidth: 180,
			itemHeight: ratio ? `${(+ratio * 0.747).toFixed(3)}vw` : "auto",
		};
	}
	return {
		itemWidth: 280,
		itemHeight: ratio ? `${(+ratio * 0.48).toFixed(3)}vw` : "auto",
	};
};

/** 转换图片url 为/ */
function transformPosterUrl(
	link: string = "",
	runtime: Partial<CommonRuntime>,
	isNoReplace?: boolean,
): string {
	if (!link) {
		return "";
	}
	if (runtime.isInApp && !runtime.userAgent?.match(/android/gi)) {
		return link;
	}

	// 链接配置的和域名一样的完整链接会去掉host，导致不能跳转，先只针对Magic banner修改
	if (!isNoReplace && /^http(s)?/.test(link)) {
		return link.replace(runtime.hostname, "");
	}
	return link;
}
